/* ============================================
   CONFIG - Configuration globale
   ============================================ */

export const CONFIG = {
  // API
  API_BASE: '/api/radar',
  MQTT_URL: 'wss://mq.thesports01.com/mqtt',

  // Dimensions par défaut du terrain
  DEFAULT_FIELD_LENGTH: 800,
  DEFAULT_FIELD_WIDTH: 500,

  // MQTT
  MQTT_CONNECT_TIMEOUT: 30000,
  MQTT_KEEPALIVE: 5,
  MQTT_RECONNECT_PERIOD: 500,
  MQTT_STAGGER_DELAY_MS: 15000, // Délai avant de lancer la connexion B (décalage pour couvrir les trous)
  MQTT_DEDUP_WINDOW_MS: 200, // Fenêtre de déduplication (ignorer les doublons reçus des 2 connexions)

  // Délais
  MESSAGE_QUEUE_CHECK_INTERVAL: 100, // ms
  STATS_UPDATE_INTERVAL: 1000, // ms
  EVENT_TIMEOUT: 5000, // ms - timeout pour les événements non utilisés

  // File d'attente d'affichage des événements
  EVENT_DISPLAY_QUEUE_MAX: 5, // Nombre max d'événements en attente
  EVENT_DISPLAY_QUEUE_TTL: 15000, // ms - durée de vie max d'un événement en file

  // Limites
  MAX_EVENTS_DISPLAY: 20,
  MAX_LOG_ENTRIES: 50,
  MAX_POSITION_HISTORY: 10,
  MAX_F5_MESSAGES_DISPLAY: 50,
};



